import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import {visionDep, mediaBias, hopeLRL, bigbio} from '../constants/projects'

const visionDepCard = (
  <React.Fragment>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {visionDep.location}
      </Typography>
      <Typography variant="h5" component="div">
        {visionDep.title}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {visionDep.authors}
      </Typography>
      <Typography variant="body">
        {visionDep.description}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {visionDep.conf}
        <br />
        {visionDep.date}
      </Typography>
    </CardContent>
    <CardActions>
      <Button size="small" href={visionDep.paper}>Paper</Button>
      <Button size="small" href={visionDep.code}>Code</Button>
    </CardActions>
  </React.Fragment>
);

const mediaBiasCard = (
  <React.Fragment>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {mediaBias.location}
      </Typography>
      <Typography variant="h5" component="div">
        {mediaBias.title}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {mediaBias.authors}
      </Typography>
      <Typography variant="body">
        {mediaBias.description}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {mediaBias.conf}
        <br />
        {mediaBias.date}
      </Typography>
    </CardContent>
    <CardActions>
      <Button size="small" href={mediaBias.paper}>Paper</Button>
      <Button size="small" href={mediaBias.code}>Code</Button>
    </CardActions>
  </React.Fragment>
);

const hopeLRLCard = (
  <React.Fragment>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {hopeLRL.location}
      </Typography>
      <Typography variant="h5" component="div">
        {hopeLRL.title}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {hopeLRL.authors}
      </Typography>
      <Typography variant="body">
        {hopeLRL.description}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {hopeLRL.conf}
        <br />
        {hopeLRL.date}
      </Typography>
    </CardContent>
    <CardActions>
      <Button size="small" href={hopeLRL.paper}>Paper</Button>
      <Button size="small" href={hopeLRL.code}>Code</Button>
    </CardActions>
  </React.Fragment>
);


const bigbioCard = (
  <React.Fragment>
    <CardContent>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {bigbio.location}
      </Typography>
      <Typography variant="h5" component="div">
        {bigbio.title}
      </Typography>
      <Typography sx={{ mb: 1.5 }} color="text.secondary">
        {bigbio.authors}
      </Typography>
      <Typography variant="body">
        {bigbio.description}
      </Typography>
    </CardContent>
    <CardActions>
      <Button size="small" href={bigbio.paper}>Paper</Button>
      <Button size="small" href={bigbio.code}>Code</Button>
    </CardActions>
  </React.Fragment>
);

export default function Project() {
  return (
    <Box >
      <Card variant="outlined">{bigbioCard}</Card>
      <Box sx={{ mb: 1 }} />
      <Card variant="outlined">{hopeLRLCard}</Card>
      <Box sx={{ mb: 1 }} />
      <Card variant="outlined">{visionDepCard}</Card>
      <Box sx={{ mb: 1 }} />
      <Card variant="outlined">{mediaBiasCard}</Card>
    </Box>
  );
}
